import React from 'react'
import TextField from './TextField'
import { themeObj } from 'components/withRoot'
import { Grid } from '@material-ui/core'
import language from 'utils/vast-languagepack'

export default () => (
  <>
    {[
      <TextField
        property="buttonText"
        label={language.signupform.add.labels.buttonText}
      />,
      <TextField
        property="buttonTextColor"
        label={language.signupform.add.labels.buttonTextColor}
        placeholder="#000000"
        color
      />,
      <TextField
        property="buttonBackgroundColor"
        label={language.signupform.add.labels.buttonBackgroundColor}
        placeholder={themeObj.palette.primary.main}
        color
      />,
    ].map((textField, idx) => (
      <Grid key={`textFieldButtonInfo${idx}`} item xs={12}>
        {textField}
      </Grid>
    ))}
  </>
)
